/**
 * Routes: / and some special routes, but all authenticated.
 *
 * Will me merged into the router's 'route' array
 */
import Home from '@/views/auth/Home.vue'
import ChangePw from '@/views/auth/ChangePw.vue'
import ChangeEmail from '@/views/auth/ChangeEmail.vue'

export default [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/change_pw',
        name: 'change_pw',
        component: ChangePw,
        meta: {
            requiresAuth: true,
            title: 'Passwort ändern',
        },
    },
    {
        path: '/change_email',
        name: 'change_email',
        component: ChangeEmail,
        meta: {
            requiresAuth: true,
            title: 'Email-Adresse ändern',
        },
    },
]
